import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '@mui/material';
import useBpmSelector from './useBpmSelector';

const BpmRange = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { recommendedBpmRange } = useBpmSelector();

  return (
    <Typography
      sx={{
        color: theme.palette.grey[400],
        fontSize: 12,
      }}
    >
      {t('aiMusicGenerator:bpmSelector:description', recommendedBpmRange)}
    </Typography>
  );
};

export default BpmRange;
